<template>
  <div>
    <transition name="fade" appear>
      <div v-if="show_notices" class="notice">
        <div class="is-flex is-align-items-center is-justify-content-space-between notice_title" :style="{ 'background-image': 'url(' + $settings.get({ path: 'background_theme' }) + ')' }">
          <p class="bold" style="font-size: 24px;">שימו לב! שינויים חדשים במערכת</p>
          <img @click="hideNotice" class="btn" src="/white_x.png" width="30px">
        </div>
        <div style="color: black; padding: 10px;">
          <div v-for="notice in notices" :key="notice" class="is-flex">
            <p>*</p>
            <div class="horizontal_space"></div>
            <p>{{notice}}</p>
          </div>
        </div>
        <div class="notice_footer">
          <p>על כל שאלה יש לפנות אל צוות המערכת.</p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'notice',
  data () {
    return {
      show_notices: false,
      notices: ['מעכשיו כפתור Vested עבר לתוך החלון של ה- Offer (אתן יכולות להיכנס אליו על ידי לחיצה על כפתור Edit)']
    }
  },
  created () {
    this.setShowNotice()
  },
  methods: {
    setShowNotice () {
      if (this.notices == undefined || this.notices.length == 0) {
        return
      }
      let local_notices = localStorage.getItem('notices')
      this.show_notices = local_notices != this.notices
    },
    hideNotice () {
      this.show_notices = false
      localStorage.setItem('notices', this.notices)
    }
  }
}
</script>
<style scoped>
  .notice{
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 67px -3px rgba(0, 0, 0, 0.75);
    position: fixed;
    direction: rtl;
    z-index: 100000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1000px;
    min-height: 510px;
    background-color: #f1f1f1;
  }
  .notice_footer{
    position: absolute;
    color: #ccc;
    width: 100%;
    padding-right: 10px;
    display: flex;
    align-items: center;
    bottom: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    height: 51px;
  }
  .notice_title{
    background-size: cover;
    background-position: 30px;
    padding: 10px 20px;
    color: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: var(--color-main);
    width: 100%;
  }
</style>
